import type { RouteRecordRaw } from 'vue-router'

export const studentsRoutes: RouteRecordRaw[] = [
  {
    path: '/students',
    name: 'students',
    component: () => import('./views/StudentsListView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin', 'staff'] },
  },
  {
    path: '/students/:id',
    name: 'student-detail',
    component: () => import('./views/StudentDetailView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin', 'staff'] },
  },
]
